import cookies from 'js-cookie'

export default async function handler(to, from, next) {

	if (to.meta.auth && cookies.get(process.env.VUE_APP_COOKIE) === undefined) {

		next({
			name: 'Login',
			query: (to.path != '/' && to.path != '/logout') ? {
				redirect: to.path
			} : {}
		})

	} else if (to.meta.auth === false && cookies.get(process.env.VUE_APP_COOKIE) !== undefined && to.name === 'Login') {

		next({
			name: 'Dashboard'
		})

	} else {

		next()

	}

}